import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { ClientAuthBoundary, convexAuthClient } from "@/lib/auth-client";
import { authConvexClient } from "@/lib/convex-clients";

export const Route = createFileRoute("/_plama")({
  component: () => (
    <ConvexBetterAuthProvider client={authConvexClient} authClient={convexAuthClient}>
      <ClientAuthBoundary>
        <div className="flex min-h-svh flex-col bg-background">
          <main className="flex-1 overflow-y-auto px-4 pt-4 pb-8">
            <Outlet />
          </main>
        </div>
      </ClientAuthBoundary>
    </ConvexBetterAuthProvider>
  ),
});
